<script setup lang="ts" name="SupportTheLegalInformation">
import BaseCard from '~/components/BaseCard.vue';
import BaseCardLink from '~/components/BaseCardLink.vue';

import type { ILegalInfoLink } from '~/types';

const { links } = defineProps<{
  links: ILegalInfoLink[];
}>();
</script>

<template>
  <BaseCard title="Legal information">
    <div class="divide-y divide-charcoal-2">
      <div
        v-for="item in links"
        :key="item.label"
        class="py-4 first:pt-0 last:pb-0"
      >
        <BaseCardLink
          v-bind="item"
          :target="item.href && '_blank'"
          rel="noopener"
        >
          {{ item.label }}
        </BaseCardLink>
      </div>
    </div>
  </BaseCard>
</template>
